import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import ComponentPlaceholder from '../../components/ComponentPlaceholder';
import RouteChildViewer from '../../components/Layout/RouteChildViewer';
import { isEmpty } from '../../utils';
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import Filters from './Filters';
import List from './List';
import Profile from './Profile';
import reducer from './reducer';
import saga from './saga';
import { makeSelectProperty } from './selector';

const PrinterProfiles = ({
  selectedBusiness,
  selectedBranch,
  selectedProfile,
}) => {
  useInjectReducer({ key: 'printerProfiles', reducer });
  useInjectSaga({ key: 'printerProfiles', saga });

  const containerEl = (() => {
    if (isEmpty(selectedBranch) || isEmpty(selectedBusiness))
      return (
        <ComponentPlaceholder label="Please select a location to see printer profiles" />
      );

    const printerProfileEl = !isEmpty(selectedProfile) ? <Profile /> : null;

    return (
      <div className="flex gap-x-4">
        <List />
        {printerProfileEl}
      </div>
    );
  })();

  return (
    <RouteChildViewer headerTitle="Printer Settings">
      <Helmet>
        <title>Printer Settings</title>
        <meta name="Printer Profiles" content="This is Printer Profiles page" />
      </Helmet>
      <div className="flex flex-col gap-y-4 rounded-lg">
        <Filters />
        {containerEl}
      </div>
    </RouteChildViewer>
  );
};

PrinterProfiles.propTypes = {
  selectedBranch: PropTypes.object,
  selectedBusiness: PropTypes.object,
  selectedProfile: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  selectedBranch: makeSelectProperty('selectedBranch'),
  selectedBusiness: makeSelectProperty('selectedBusiness'),
  selectedProfile: makeSelectProperty('selectedProfile'),
});

const mapDispatchToProps = dispatch => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(PrinterProfiles);
